import apiService from 'services/apiService';

const monitorApiUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const patchUnarchiveClient = (entityId) => {
  const url = `${monitorApiUrl}/v1/entities/${entityId}/unarchive`;
  return apiService.patch(url);
};

export { patchUnarchiveClient };
